import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
const clearAction = createAction("clear");

export type LanguageOptions = "de" | "en" | "";

export interface LoginState {
  subjectId: string | number;
  companyName: string;
  firstname: string;
  lastname: string;
  email: string;
  permissions: string[];
  company_enforced_two_factor: boolean;
  group_set: string[];
  preferred_language: LanguageOptions;
  userId: string;
  assigned_companies: any[];
  department_manager_for: string[];
  hasCourseEnrolments: boolean;
}

const initialState: LoginState = {
  subjectId: "",
  companyName: "",
  firstname: "",
  lastname: "",
  email: "",
  permissions: [],
  company_enforced_two_factor: false,
  group_set: [],
  preferred_language: "",
  userId: "",
  assigned_companies: [],
  department_manager_for: [],
  hasCourseEnrolments: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLogin: (
      state,
      action: PayloadAction<{
        subjectId: string | number;
        companyName: string;
        firstname: string;
        lastname: string;
        email: string;
        permissions: [];
        company_enforced_two_factor: boolean;
        group_set: [];
        preferred_language: LanguageOptions;
        userId: string;
        assigned_companies: [];
        department_manager_for: [];
        hasCourseEnrolments: boolean;
      }>
    ) => {
      state.subjectId = action.payload.subjectId;
      state.companyName = action.payload.companyName;
      state.firstname = action.payload.firstname;
      state.lastname = action.payload.lastname;
      state.email = action.payload.email;
      state.permissions = action.payload.permissions;
      state.company_enforced_two_factor =
        action.payload.company_enforced_two_factor;
      state.group_set = action.payload.group_set;
      state.preferred_language = action.payload.preferred_language;
      state.userId = action.payload.userId;
      state.assigned_companies = action.payload.assigned_companies;
      state.department_manager_for = action.payload.department_manager_for;
      state.hasCourseEnrolments = action.payload.hasCourseEnrolments;
    },
    setPreferredLanguage: (state, action: PayloadAction<LanguageOptions>) => {
      state.preferred_language = action.payload;
    },
    setHasCourseEnrolments: (state, action: PayloadAction<boolean>) => {
      state.hasCourseEnrolments = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearAction, (state) => {
      const preservedLanguage = state.preferred_language;
      return {
        ...initialState,
        preferred_language: preservedLanguage,
      };
    });
  },
});

export const {
  setLogin: setLogin,
  setPreferredLanguage: setPreferredLanguage,
  setHasCourseEnrolments,
} = loginSlice.actions;
export default loginSlice.reducer;
